import * as React from "react";
import i18n from "../i18n";
import { getCurrentUser } from "../shared/getCurrentUser";
import { NavBarContainer } from "./NavBarContainer";
import { UserInfoAndLicencesSection } from "./UserInfoAndLicencesSection";

export function WebAppHome() {
  const userInfo = getCurrentUser();

  return (
    <NavBarContainer title="">
      <p>{i18n.t("home.welcome", { name: userInfo!.Name })}</p>
      <UserInfoAndLicencesSection userInfo={userInfo!} />
    </NavBarContainer>
  );
}
